var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._g(_vm._b({tag:"component",staticClass:"button",class:_vm.classes,attrs:{"to":_vm.to}},'component',_vm.$attrs,false),_vm.$listeners),[(_vm.type === 'tertiary')?_c('span',{staticClass:"button-content"},[_vm._t("default")],2):_vm._t("default"),_vm._v(" "),(_vm.type === 'tertiary')?_c('q-icon',{class:{
      'ml-1': !_vm.reversed
    },attrs:{"name":"chevron-right"}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }